import SectionAncestry from './SectionAncestry'

export default SectionAncestry
